/**
 * [ File :: G_World.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/frame/G_World.js
 * @목적 : 그리드 타입 월드
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

// # frame & util & model
import B_Util      from 'canvas/base/dev/util/B_Util'
import B_Define    from 'canvas/base/dev/util/B_Define';
import B_State     from 'canvas/base/dev/model/B_State';
import B_World     from 'canvas/base/dev/frame/B_World';
import G_Define    from 'canvas/grid/dev/util/G_Define';
import G_Tick      from 'canvas/grid/dev/frame/G_Tick';

// # child
import B_Grid           from 'canvas/base/dev/child/grid/B_Grid';
import G_GraphicHero    from 'canvas/grid/dev/child/graphic/G_GraphicHero';
import G_ImageInspector from 'canvas/grid/dev/child/image/G_ImageInspector';
import G_ImageGoal      from 'canvas/grid/dev/child/image/G_ImageGoal';
import G_ImageGrid      from 'canvas/grid/dev/child/image/G_ImageGrid';
import G_ImageHitItem   from 'canvas/grid/dev/child/image/G_ImageHitItem';
import G_ImagePushItem  from 'canvas/grid/dev/child/image/G_ImagePushItem';
import G_ImagePath      from 'canvas/grid/dev/child/image/G_ImagePath';
import G_ImagePortal    from 'canvas/grid/dev/child/image/G_ImagePortal';
import G_ImageSwitch    from 'canvas/grid/dev/child/image/G_ImageSwitch';
import G_ImageDeco      from 'canvas/grid/dev/child/image/G_ImageDeco';
import G_Solution   	from 'canvas/grid/dev/child/attr/G_Solution';
import G_Variable 		from 'canvas/grid/dev/child/graphic/G_Variable'
import G_VariableReal 	from 'canvas/grid/dev/child/attr/G_VariableReal'
import G_SpriteHero from 'canvas/grid/dev/child/graphic/G_SpriteHero';

const G_World = (function(){

	return class extends B_World {

		constructor(cm) {
			super(cm);

			// [S] list, state
			this.CODMOS.REASON = G_Define.REASON;
			this.initList(G_Define.LIST);   // LIST
			this.STATE = new B_State();    // STATE (게임진행 상태값)
		}

		// [F]

		// @OVERRIDING
		tick() {
			super.tick();
			G_Tick.tickSwal(this);
			G_Tick.tickVariableReload(this);
			G_Tick.valueShowing(this);
		}

		/**
		 * @DESC :: 가상 리스트 추가
		 * @arg1 ::
		 */
		addVirtual(id, type, x, y) {
			if(!this.LIST.virtual[id]) {
				// init
				this.LIST.virtual[id] = {
					arrGrid : [ [x, y] ],
					type    : type,
					enable  : true
				}
			}
			else {
				// update
				this.LIST.virtual[id].arrGrid.push([x, y])
			}
		}

		/**
		 * @DESC :: 가상 리스트 제거
		 * @arg1 ::
		 */
		removeVirtual(id) {
			delete this.LIST.virtual[id];
		}

		// @OVERRIDING
		addObject(obj) {
			super.addObject(obj); // [E]

			let instance;
			switch (obj.type) {
				case B_Define.GRID_TYPE:
					instance = new B_Grid(obj);
					break;
				case G_Define.PATH_TYPE:
					instance = new G_ImagePath(obj);
					break;
				case B_Define.DECO_TYPE:
					instance = new G_ImageDeco(obj);
					break;
				case G_Define.GOAL_TYPE:
					instance = new G_ImageGoal(obj);
					break;
				case G_Define.INSPECTOR_TYPE:
					instance = new G_ImageInspector(obj);
					break;
				case G_Define.GET_ITEM_TYPE:
					instance = new G_ImageGrid(obj);
					break;
				case G_Define.ACTION_ITEM_TYPE:
					instance = new G_ImageGrid(obj);
					break;
				case G_Define.HIT_ITEM_TYPE:
					instance = new G_ImageHitItem(obj);
					break;
				case G_Define.PUSH_ITEM_TYPE:
					instance = new G_ImagePushItem(obj);
					break;
				case G_Define.OBSTACLE_TYPE:
					instance = new G_ImageGrid(obj);
					break;
				case G_Define.PORTAL_TYPE:
					instance = new G_ImagePortal(obj);
					break;
				case G_Define.SWITCH_TYPE:
					instance = new G_ImageSwitch(obj);
					break;
				case G_Define.HERO_TYPE:
					instance = new G_GraphicHero(obj);
					break;
				case B_Define.SOLUTION_TYPE:
				case B_Define.ITEM_SOLUTION_TYPE:
					instance = new G_Solution(obj);
					break;
				case G_Define.VARIABLE_REAL_TYPE:
					instance = new G_VariableReal(obj)
					break
				case G_Define.VARIABLE_TYPE:
					instance = new G_Variable(obj)
					break
				case 'ssHero': {
					instance = new G_SpriteHero(obj);
					break;
				}
				default :
					B_Util.print(B_Define.MESSAGE['NO_CHILD_TYPE']);
					return;
					break;
			}

			// [#] 'real' 타입만 캔버스에 추가.
			if (instance._container) {
				instance._setArea();  // [S] width & height 재조정
				instance._setPoint(); // [S] point(reg) 재조정

				// parent check
				if(obj.parent) { this[obj.parent]._container.addChild(this[obj.id]._container); }
				else           { this.addChild(this[obj.id]._container); }
			}

			return B_Util.getProtected(instance);
		}
	}
}());

export default G_World;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/frame/G_World.js